module.exports = __webpack_public_path__ + "static/media/img-card-five.c6379f0f.jpg";